import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNiches } from '../hooks/useNiches';
import { getNicheIcon } from '../utils/nicheIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import PublicSponsorPreviewGrid from './PublicSponsorPreviewGrid';
import '../css/components/HomeNicheSearch.css';

// The "All" pill's value in local state — never a real niche tag (server
// tags are always real category names), so it can't collide with one.
const ALL_SENTINEL = '__all__';

// Free, no-signup search by niche — only niches with enough real sponsors
// to be worth showing publicly (see NICHE_FREE_SEARCH_MIN server-side)
// appear here at all, so this section only exists once there's something
// real to show, and grows on its own as the database does.
const HomeNicheSearch: React.FC = () => {
    const { niches, loading } = useNiches();
    const searchable = niches.filter((n) => n.freeSearch);
    const [selected, setSelected] = useState<string>(ALL_SENTINEL);

    if (loading || searchable.length === 0) {
        return null;
    }

    return (
        <div className="home-niche-search">
            <div className="home-niche-search__pills">
                <button
                    type="button"
                    className={`home-niche-search__pill ${selected === ALL_SENTINEL ? 'active' : ''}`}
                    onClick={() => setSelected(ALL_SENTINEL)}
                >
                    <FontAwesomeIcon icon={faDatabase} />
                    All
                </button>
                {searchable.map((niche) => (
                    <button
                        key={niche.tag}
                        type="button"
                        className={`home-niche-search__pill ${selected === niche.tag ? 'active' : ''}`}
                        onClick={() => setSelected(niche.tag)}
                    >
                        <FontAwesomeIcon icon={getNicheIcon(niche.tag)} />
                        {niche.tag}
                    </button>
                ))}
            </div>
            <PublicSponsorPreviewGrid niche={selected === ALL_SENTINEL ? undefined : selected} />
            {/* Minimal — the full "here's what you get, subscribe" pitch
                already lives on the standalone free-database page this
                links to (see NicheLanding); this just points there. */}
            <Link
                to={`/niche/${selected === ALL_SENTINEL ? 'all' : encodeURIComponent(selected)}`}
                className="home-niche-search__see-more"
            >
                See the full free preview <FontAwesomeIcon icon={faArrowRight} />
            </Link>
        </div>
    );
};

export default HomeNicheSearch;
